import { growthbook } from "@/growthbook";

export type TDownloadLinks = {
  apple_m1: string;
  apple_intel: string;
  windows: string;
  version: string;
};

const DEFAULT_DOWNLOAD_LINKS =
  '{"apple_m1": "https://download.aftershoot.com/installer/m1/Aftershoot.zip","apple_intel": "https://download.aftershoot.com/installer/m1/Aftershoot.zip","windows": "https://download.aftershoot.com/edits-alpha/windows/AfterShoot-win-latest-2.7.1123.exe","version": "2.7.11230"}';

export const fetchDownloadLinks = () => {
  const data = growthbook.getFeatureValue(
    "restructuring-split",
    DEFAULT_DOWNLOAD_LINKS,
  );

  const downloadLinks = JSON.parse(data) as TDownloadLinks;

  return downloadLinks;
};
